import FormHelpers from './form-helpers';
import Helpers from './helpers';

const RequiredInputValidation = {
	checkForm(inputs) {
		let filled = true;
		for (let i = 0; i < inputs.length; i += 1) {
			if (inputs[i].hasAttribute('required')) {
				switch (inputs[i].type) {
					case 'checkbox':
						if (!inputs[i].checked) {
							filled = false;
						}
						break;
					default:
						if (!inputs[i].value || !Helpers.checkWhitespace(inputs[i].value)) {
							filled = false;
						}
				}
			}
		}
		if (FormHelpers.validateRadioButtons(inputs)) {
			filled = false;
		}

		if (filled) {
			Helpers.enableAllButtons();
		} else {
			Helpers.disableAllButtons();
		}
	},
};

export default RequiredInputValidation;
